import { render, staticRenderFns } from "./Strategyfactory.vue?vue&type=template&id=6c3b889a&scoped=true"
import script from "./Strategyfactory.vue?vue&type=script&lang=js"
export * from "./Strategyfactory.vue?vue&type=script&lang=js"
import style0 from "./Strategyfactory.vue?vue&type=style&index=0&id=6c3b889a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3b889a",
  null
  
)

export default component.exports